import React, { FC } from "react";
import { GroupBlockEntityType } from "../../../configMap";
import EntityCell from "./entityCell/EntityCell";
import useTableEntityCell from "../../hooks/useTableEntityCell";
import "./TableEtityCell.scss";

type Props = {
  groupBlockEntityType: GroupBlockEntityType;
  groupBlockIndex: number;
  disabled: boolean;
};

const TableEntityCell: FC<Props> = ({
  groupBlockEntityType,
  groupBlockIndex,
  disabled,
}) => {
  const { elRef, requiresScoreAttention, cellWidth, isCellWidthDefined } =
    useTableEntityCell(groupBlockEntityType, groupBlockIndex);

  return (
    <div className="entity-cell-wrapper" ref={elRef}>
      <EntityCell
        groupBlockEntityType={groupBlockEntityType}
        groupBlockIndex={groupBlockIndex}
        disabled={disabled}
        requiresAttention={requiresScoreAttention}
        cellWidth={cellWidth}
        isCellWidthDefined={isCellWidthDefined}
      />
    </div>
  );
};

export default TableEntityCell;
